import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import projects from "./projectsData";

// Leaflet (mapa sa pinovima)
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix za Leaflet ikonice u CRA build-u
import iconRetinaUrl from "leaflet/dist/images/marker-icon-2x.png";
import iconUrl from "leaflet/dist/images/marker-icon.png";
import shadowUrl from "leaflet/dist/images/marker-shadow.png";
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({ iconRetinaUrl, iconUrl, shadowUrl });

const asArray = (x) => (Array.isArray(x) ? x : []);

function ProjectSingleLANDS() {
  const { t } = useTranslation("projectsTranslation");

  const project = useMemo(
    () => projects.find((p) => p.i18nKey === "lands"),
    []
  );

  const baseKey = "projects.lands";

  const intro = asArray(t(`${baseKey}.page.intro`, { returnObjects: true }));
  const longDescription = asArray(
    t(`${baseKey}.page.longDescription`, { returnObjects: true })
  );
  const objectives = asArray(
    t(`${baseKey}.page.objectives.items`, { returnObjects: true })
  );

  const lead = t(`${baseKey}.page.partnership.leadPartner`, {
    returnObjects: true,
  });

  const partners = asArray(
    t(`${baseKey}.page.partnership.partners`, { returnObjects: true })
  );

  const contacts = asArray(
    t(`${baseKey}.page.contacts.items`, { returnObjects: true })
  );

  const projectWebsite = t(`${baseKey}.page.partnership.projectWebsite`);

  // CUSTOM accordion (bez Bootstrap JS)
  const [openIdx, setOpenIdx] = useState(0);
  const allPartners = useMemo(() => {
    const list = [];
    if (lead?.name) list.push({ ...lead, __isLead: true });
    partners.forEach((p) => p?.name && list.push({ ...p, __isLead: false }));
    return list;
  }, [lead, partners]);

  // GEO koordinate za pinove (po gradu)
  const coordByCity = useMemo(
    () => ({
      Split: [43.5081, 16.4402],
      Ajdovščina: [45.8869, 13.908],
      Ajdovscina: [45.8869, 13.908],
      Thessaloniki: [40.6401, 22.9444],
      Bologna: [44.4949, 11.3426],
      Rome: [41.9028, 12.4964],
      Bar: [42.093, 19.1],
      Čačak: [43.8914, 20.3497],
      Cacak: [43.8914, 20.3497],
      Skopje: [41.9973, 21.428],
      Derventa: [44.9799, 17.9097],
      Tirana: [41.3275, 19.8187],
      Berovo: [41.7062, 22.8563],
    }),
    []
  );

  const mapPins = useMemo(() => {
    return allPartners
      .map((p) => {
        const city = (p?.city || "").trim();
        const coords =
          coordByCity[city] ||
          coordByCity[city.replace("č", "c").replace("Č", "C")] ||
          null;

        if (!coords) return null;

        return {
          name: p?.name,
          city: p?.city,
          country: p?.country,
          website: p?.website,
          isLead: !!p.__isLead,
          lat: coords[0],
          lng: coords[1],
        };
      })
      .filter(Boolean);
  }, [allPartners, coordByCity]);

  return (
    <>
      <Navbar />
      <Bredcom />

      <div className="container mt-4 pt-40 project-detail lands-page">
        <div className="row">
          {/* MAIN */}
          <div className="col-lg-8 col-md-7">
            <div className="content-container lower-content">
              {/* Logos + EU funding */}
              <div className="project-logos mb-4" style={{ gap: 14 }}>
                {project?.logos?.project && (
                  <img
                    src={project.logos.project}
                    alt="LANDS logo"
                    className="project-logo-project"
                    style={{ maxHeight: 64, width: "auto" }}
                  />
                )}

                <span className="project-eu-text">
                  {t(`${baseKey}.page.euFunding`)}
                </span>
              </div>

              {/* Cover */}
              {project?.coverImage && (
                <div className="project-cover mb-4">
                  <img
                    src={project.coverImage}
                    alt={t(`${baseKey}.page.title`)}
                    className="img-fluid"
                    style={{ borderRadius: 16, width: "100%" }}
                  />
                </div>
              )}

              <h2 className="section-title">{t(`${baseKey}.page.title`)}</h2>

              {/* Intro */}
              <div className="textjustify">
                {intro.map((p, i) => (
                  <p key={i} style={{ marginBottom: 12 }}>
                    {p}
                  </p>
                ))}
              </div>

              {/* Long description */}
              <div className="textjustify mt-20">
                {longDescription.map((p, i) => (
                  <p key={i} style={{ marginBottom: 12 }}>
                    {p}
                  </p>
                ))}
              </div>

              {/* Objectives */}
              <h3 className="mt-30">{t(`${baseKey}.page.objectives.title`)}</h3>
              <div className="values-section lands-values--objectives">
                <ul>
                  {objectives.map((it, idx) => (
                    <li key={idx}>{it}</li>
                  ))}
                </ul>
              </div>

              {/* Partnership map */}
              <h3 className="mt-30">
                {t(`${baseKey}.page.partnership.title`)}
              </h3>
              <div className="lands-map-wrap">
                <MapContainer
                  center={[43.2, 18.7]}
                  zoom={5}
                  scrollWheelZoom={false}
                  className="lands-leaflet-map"
                >
                  <TileLayer
                    attribution="&copy; OpenStreetMap contributors"
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  />

                  {mapPins.map((p, idx) => (
                    <Marker key={idx} position={[p.lat, p.lng]}>
                      <Popup>
                        <div style={{ maxWidth: 230 }}>
                          <strong>
                            {p.isLead ? "★ " : ""}
                            {p.name}
                          </strong>
                          <div style={{ fontSize: 13, marginTop: 6 }}>
                            {p.city}
                            {p.country ? `, ${p.country}` : ""}
                          </div>

                          {p.website && (
                            <div style={{ marginTop: 8 }}>
                              <a
                                href={p.website}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <i className="fas fa-globe" /> Website
                              </a>
                            </div>
                          )}
                        </div>
                      </Popup>
                    </Marker>
                  ))}
                </MapContainer>
              </div>

              {/* Partners accordion */}
              <div className="values-section mt-25">
                <h3 style={{ marginBottom: 12 }}>
                  {t(`${baseKey}.page.partnership.partnersTitle`)}
                </h3>

                <div className="lands-accordion">
                  {allPartners.map((p, idx) => {
                    const isOpen = openIdx === idx;

                    return (
                      <div
                        key={`${p.name}-${idx}`}
                        className={`lands-acc-item ${isOpen ? "is-open" : ""}`}
                      >
                        <button
                          type="button"
                          className="lands-acc-btn"
                          onClick={() => setOpenIdx(isOpen ? -1 : idx)}
                        >
                          <span className="lands-acc-left">
                            <span className="lands-acc-title">
                              {p.__isLead ? (
                                <span className="lands-lead-badge">
                                  <i className="fas fa-star" />{" "}
                                  {t(`${baseKey}.sidebar.leadPartnerLabel`)}
                                </span>
                              ) : null}
                              {p.name}
                            </span>

                            {(p.city || p.country) && (
                              <span className="lands-acc-sub">
                                {p.city}
                                {p.country ? `, ${p.country}` : ""}
                              </span>
                            )}
                          </span>

                          <span className="lands-acc-icon">
                            {isOpen ? "–" : "+"}
                          </span>
                        </button>

                        <div
                          className="lands-acc-panel"
                          style={{ display: isOpen ? "block" : "none" }}
                        >
                          {p.address && (
                            <div className="lands-acc-row">
                              <i className="fas fa-map-marker-alt" />
                              <span>{p.address}</span>
                            </div>
                          )}

                          {(p.contactPerson || p.email) && (
                            <div className="lands-acc-row">
                              <i className="fas fa-user" />
                              <span>
                                {p.contactPerson ? p.contactPerson : ""}
                                {p.email ? (
                                  <>
                                    {p.contactPerson ? " · " : ""}
                                    <a href={`mailto:${p.email}`}>{p.email}</a>
                                  </>
                                ) : null}
                              </span>
                            </div>
                          )}

                          {p.website && (
                            <div className="lands-acc-row">
                              <i className="fas fa-globe" />
                              <a
                                href={p.website}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {p.website}
                              </a>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>

          {/* SIDEBAR */}
          <div className="col-lg-4 col-md-5">
            <div className="info-column">
              <div className="inner-column3">
                <h3>{t(`${baseKey}.sidebar.title`)}</h3>

                <ul className="project-info">
                  <li>
                    <span className="icon">
                      <i className="fas fa-project-diagram" />
                    </span>
                    <h5>{t(`${baseKey}.sidebar.projectTitleLabel`)}</h5>
                    <p>{t(`${baseKey}.page.title`)}</p>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fas fa-layer-group" />
                    </span>
                    <h5>{t(`${baseKey}.sidebar.programmeLabel`)}</h5>
                    <p>{t(`${baseKey}.page.meta.programme`)}</p>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fas fa-calendar-alt" />
                    </span>
                    <h5>{t(`${baseKey}.sidebar.durationLabel`)}</h5>
                    <p>{t(`${baseKey}.page.meta.startEnd`)}</p>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fas fa-coins" />
                    </span>
                    <h5>{t(`${baseKey}.sidebar.budgetLabel`)}</h5>
                    <p>{t(`${baseKey}.page.meta.totalBudget`)}</p>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fas fa-hand-holding-usd" />
                    </span>
                    <h5>{t(`${baseKey}.sidebar.fundsLabel`)}</h5>
                    <p>{t(`${baseKey}.page.meta.interregFunds`)}</p>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fas fa-university" />
                    </span>
                    <h5>{t(`${baseKey}.sidebar.leadPartnerLabel`)}</h5>
                    <p style={{ marginBottom: 6 }}>{lead?.name}</p>

                    {(lead?.contactPerson || lead?.email) && (
                      <p style={{ marginBottom: 0 }}>
                        <i className="fas fa-user" /> {lead?.contactPerson}
                        {lead?.email ? (
                          <>
                            {" "}
                            · <a href={`mailto:${lead.email}`}>{lead.email}</a>
                          </>
                        ) : null}
                      </p>
                    )}
                  </li>

                  {contacts.length > 0 && (
                    <li>
                      <span className="icon">
                        <i className="fas fa-address-book" />
                      </span>
                      <h5>{t(`${baseKey}.page.contacts.title`)}</h5>
                      <p style={{ marginBottom: 0 }}>
                        {contacts.map((c, idx) => (
                          <span key={idx}>
                            <strong>{c.label}:</strong>{" "}
                            {c.email ? (
                              <a href={`mailto:${c.email}`}>{c.value}</a>
                            ) : (
                              c.value
                            )}
                            {idx < contacts.length - 1 ? <br /> : null}
                          </span>
                        ))}
                      </p>
                    </li>
                  )}

                  {projectWebsite && (
                    <li>
                      <span className="icon">
                        <i className="fas fa-globe" />
                      </span>
                      <h5>{t(`${baseKey}.sidebar.websiteLabel`)}</h5>
                      <p style={{ marginBottom: 0 }}>
                        <a
                          href={projectWebsite}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="fas fa-external-link-alt" />{" "}
                          {projectWebsite}
                        </a>
                      </p>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default ProjectSingleLANDS;
